import arrayWithHoles from './_array_with_holes.mjs';
import iterableToArrayLimit from './_iterable_to_array.mjs';
import nonIterableRest from './_non_iterable_rest.mjs';
import unsupportedIterableToArray from './_unsupported_iterable_to_array.mjs';

export default function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
